import { PLACE_ORDER } from "./actionTypes";
import { BOOK_SERVICE } from "./actionTypes";
import { BOOK_SERVICE_URL  } from "../../configs";
import { PLACE_ORDER_URL, keyValue  } from "../../configs";
import { APPLY_COUPON } from "../coupon/actionTypes";

import Axios from "axios";
import { updateCart } from "../total/actions";

export const placeOrder = (
	seller_id,
	customer_name,
	customer_id,
	customer_phone,
	customer_email,
	address,
	city,
	state,
	country,
	zipcode,
	total_amount,
	coupon,
	couponpercentage,
	tax,
	shipping_charge,
	payment_type,
	products
) => (dispatch, getState) => {
	Axios.defaults.headers.common = {
          "X-API-Key": keyValue,
        };
		
	Axios.post(PLACE_ORDER_URL, {
		seller_id : seller_id,
		customer_name : customer_name,
		customer_id	: customer_id,
		customer_phone 	: customer_phone,
		customer_email 	: customer_email,
		address: address,
		city	: city,
		state 	: state,
		country : country,
		zipcode : zipcode,
		total_amount : total_amount,
		coupon	: coupon,
		couponpercentage	: couponpercentage,
		tax	: tax,
		shipping_charge	: shipping_charge,
		payment_type : payment_type,
		products : products,
	})
		.then(response => {
			const checkout = response.data;

			if (checkout.success) {
				dispatch({ type: PLACE_ORDER, payload: checkout });

				const state = getState();
				// console.log(state);
				const cartProducts = state.cart.products;
				// const user = state.user.user;
				localStorage.removeItem("orderComment");

				for (let i = cartProducts.length - 1; i >= 0; i--) {
					// remove all items from cart
					cartProducts.splice(i, 1);
				}

				dispatch(updateCart(cartProducts));

				localStorage.removeItem("appliedCoupon");
				const coupon = [];
				dispatch({ type: APPLY_COUPON, payload: coupon });
			}
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const payService = (
		service_id,
		service_type,
		price,
		seller_id,
		customer_id,
		customer_name,
		customer_email,
		customer_phone,
		booking_date,
		booking_time,
		staffid,
		payment_mode,
		paypal_payment_id,
		trial_price_status
) => (dispatch) => {
	Axios.defaults.headers.common = {
          "X-API-Key": keyValue,
        };
		
	Axios.post(BOOK_SERVICE_URL, {
		service_id : service_id,
		service_type : service_type,
		price	: price,
		seller_id	: seller_id,
		customer_id : customer_id,
		customer_name : customer_name,
		customer_email : customer_email,
		customer_phone : customer_phone,
		booking_date : booking_date,
		booking_time : booking_time,
		staffid : staffid,
		payment_mode : payment_mode,
		paypal_payment_id : paypal_payment_id,
		trial_price_status : trial_price_status,
	})
		.then(response => {
			const payservice = response.data;
			return dispatch({ type: BOOK_SERVICE, payload: payservice });				

		})
		.catch(function(error) {
			console.log(error);
		});
};
